import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../core/services/api.service';
import { ILazyApiResult } from '../core/services/api/api-result';
import { QueryParams } from '../core/services/api/query-params';

export abstract class GenericService<T> {
  public api: ApiService<T>;

  constructor(http: HttpClient) {
    this.api = new ApiService<T>(http);
  }

  abstract get(queryParams?: QueryParams, context?: { [key: string]: any }): Observable<ILazyApiResult<T>>;

  /**
   * Default getAll, removes API default limit, to override for specific usage
   *
   * @returns
   */
  getAll(context?: { [key: string]: any }): Observable<T[]> {
    const qParam = new QueryParams();
    qParam.limit = 0;
    return this.get(qParam).pipe(map((res) => res.result));
  }

  abstract getOne(id: number | string, context?: { [key: string]: any }): Observable<T>;

  abstract create?(item: T, context?: { [key: string]: any }): Observable<T>;

  abstract update?(item: T, context?: { [key: string]: any }): Observable<T>;

  abstract delete?(id: number, context?: { [key: string]: any }): Observable<void>;
}
